import { createContext } from "react";

export interface AtsIntegration {
  oauth_token_endpoint: string;
  wsdl_endpoint: string;
  oauth_client_id: string;
  oauth_client_secret: string;
  oauth_refresh_token: string;
  oauth_refresh_token_expiry?: string;
  oauth_refresh_token_lifetime: number;
  report_url_type: string;
  should_create_users_just_in_time: boolean;
  packages: string[];
}

export interface WorkdayConfig {
  access_token: string;
  client_id: string;
  client_secret: string;
  refresh_token: string;
  incoming_webhook_endpoint: string;
  token_endpoint: string;
}

export interface WorkdayIntegrationContextType {
  atsIntegrationData: AtsIntegration;
  workdayConfig: WorkdayConfig | null;
  currentStep: number;
  setAtsIntegration: (atsIntegrationData: AtsIntegration) => void;
  setWorkdayConfig: (workdayConfig: WorkdayConfig) => void;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const WorkdayIntegrationContext =
  createContext<WorkdayIntegrationContextType>({
    atsIntegrationData: {
      oauth_token_endpoint: "",
      wsdl_endpoint: "",
      oauth_client_id: "",
      oauth_client_secret: "",
      oauth_refresh_token: "",
      oauth_refresh_token_lifetime: 0,
      report_url_type: "",
      should_create_users_just_in_time: false,
      packages: [],
    },
    setAtsIntegration: (newState: AtsIntegration) => newState,
    workdayConfig: null,
    setWorkdayConfig: (workdayConfig: WorkdayConfig) => workdayConfig,
    currentStep: 0,
    goToNextStep: () => {},
    goToPrevStep: () => {},
  });
